import { Controller, useFormContext } from 'react-hook-form';
import { Input, Tooltip } from '@dsi/react-eds';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import styles from './CustomerSettingsForm.module.css';
import { useState } from 'react';

const CustomerSettingsForm: React.FC = () => {
  const { control, formState: { errors } } = useFormContext();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={styles.form}>
      <div className={styles.formRow}>
        <div className={styles.fieldWrapper}>
          <label htmlFor="euft">
            Customer ID/EUFT
            <ReactEDSWrapper
              component={Tooltip}
              message="Enter unique ID that groups services sharing the same deployment target or configuration."
              pointer
            >
              <span>
                <i className={`icon icon-info ${styles.infoIcon}`}></i>
              </span>
            </ReactEDSWrapper>
          </label>
          <Controller
            name="euft"
            control={control}
            render={({ field }) => (
              <ReactEDSWrapper
                component={Input}
                id="euft"
                autoComplete="off"
                fullwidth
                readOnly
                className={errors.euft ? `${styles.inputField} ${styles.inputError}` : styles.inputField}
                {...field}
              />
            )}
          />
          {errors.euft && (
            <span className={styles.error}>
              <span className={styles.dangerIcon} aria-label="error" role="img">&#9888;</span>
              {typeof errors.euft.message === 'string' ? errors.euft.message : 'Required'}
            </span>
          )}
        </div>

        <div className={styles.fieldWrapper}>
          <label htmlFor="euft_name" className={styles.inputLabel}>
            Customer Name
          </label>
          <Controller
            name="euft_name"
            control={control}
            render={({ field }) => (
              <ReactEDSWrapper
                component={Input}
                id="euft_name"
                autoComplete="off"
                fullwidth
                readOnly
                className={errors.euft_name ? `${styles.inputField} ${styles.inputError}` : styles.inputField}
                {...field}
              />
            )}
          />
          {errors.euft_name && (
            <span className={styles.error}>
              <span className={styles.dangerIcon} aria-label="error" role="img">&#9888;</span>
              {typeof errors.euft_name.message === 'string' ? errors.euft_name.message : 'Required'}
            </span>
          )}
        </div>
      </div>

      <div className={`${styles.formRow} ${styles.sectionSpacing}`}>
        <div className={styles.fieldWrapper}>
          <label htmlFor="api_url">
            SWGW URL <ReactEDSWrapper component={Tooltip} message="Enter the full URL of the Software Gateway used for scanning." pointer>
              <span>
                <i className={`icon icon-info ${styles.infoIcon}`}></i>
              </span>
            </ReactEDSWrapper>
          </label>
          <Controller
            name="api_url"
            control={control}
            render={({ field }) => (
              <div>{field.value}</div>
            )}
          />
        </div>
      </div>

      <div className={`${styles.formRow} ${styles.sectionSpacing}`}>
        <div className={styles.fieldWrapper}>
          <label htmlFor="baseUrl">
            Base URL
            <ReactEDSWrapper
              component={Tooltip}
              message="The base URL for API requests. This is typically the root endpoint for your environment."
              pointer
            >
              <span>
                <i className={`icon icon-info ${styles.infoIcon}`}></i>
              </span>
            </ReactEDSWrapper>
          </label>
          <div id="baseUrl">
            https://login.microsoftonline.com/92e84ceb-fbfd-47ab-be52-080c6b87953f/oauth2/v2.0/token
          </div>
        </div>
      </div>

      <div className={`${styles.formRow} ${styles.sectionSpacing}`}>
        <div className={styles.field}>
          <label htmlFor="client_key">
            Client Key <span className={styles.requiredAsterisk}> *</span> <ReactEDSWrapper component={Tooltip} message="Enter the client key issued by the identity provider." pointer>
              <span>
                <i className={`icon icon-info ${styles.infoIcon}`}></i>
              </span>
            </ReactEDSWrapper>
          </label>
          <Controller
            name="client_key"
            control={control}
            render={({ field }) => (
              <ReactEDSWrapper
                component={Input}
                id="client_key"
                type="text"
                autoComplete="off"
                fullwidth
                className={errors.client_key ? `${styles.inputField} ${styles.inputError}` : styles.inputField}
                {...field}
              />
            )}
          />
          {errors.client_key && (
            <span className={styles.error}>
              <span className={styles.dangerIcon} aria-label="error" role="img">&#9888;</span>
              {typeof errors.client_key.message === 'string' ? errors.client_key.message : 'Required'}
            </span>
          )}
        </div>

        <div className={styles.fieldPassword}>
          <label htmlFor="client_secret" className={styles.inputLabel}>
            Secret Key <span className={styles.requiredAsterisk}> *</span>
          </label>
          <Controller
            name="client_secret"
            control={control}
            render={({ field }) => (
              <ReactEDSWrapper
                component={Input}
                autoComplete="new-password"
                id="client_secret"
                icon={showPassword ? 'icon icon-invisible' : 'icon icon-eye'}
                onIconClick={() => setShowPassword(!showPassword)}
                type={showPassword ? 'text' : 'password'}
                fullwidth
                className={errors.client_secret ? `${styles.inputField} ${styles.inputError}` : styles.inputField}
                {...field} />
            )}
          />
          {errors.client_secret && (
            <span className={styles.error}>
              <span className={styles.dangerIcon} aria-label="error" role="img">&#9888;</span>
              {typeof errors.client_secret.message === 'string' ? errors.client_secret.message : 'Required'}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerSettingsForm;
